import axios from 'axios'
import {APIHOST} from "@/settings";
import SessionStorage from "sessionstorage";

class CompanyParamsService {
    getAll() {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.get(`${APIHOST}/api/CompanyParam`, {
            headers: {'Authorization': `Bearer ${oAuthAccess.access_token}`}
        });
    }

    get(key) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.get(`${APIHOST}/api/CompanyParam`, {
            headers: {'Authorization': `Bearer ${oAuthAccess.access_token}`},
            params: {
                id: key
            }
        });
    }

    save(key, value) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.post(`${APIHOST}/api/CompanyParam`, {
            Key: key,
            Value: value
        },{
            headers: {'Authorization': `Bearer ${oAuthAccess.access_token}`}
        });
    }

    delete(key) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.delete(`${APIHOST}/api/CompanyParam`, {
            headers: {'Authorization': `Bearer ${oAuthAccess.access_token}`},
            params: {
                id: key
            }
        });
    }
}

export default new CompanyParamsService()
